export const DEFAULT_SLA_MINUTES = 15;

export function getSlaMinutesFromConfig(config) {
  const fromExtra = Number(config?.extra?.sla_response_minutes);
  if (Number.isFinite(fromExtra) && fromExtra > 0) return fromExtra;
  return DEFAULT_SLA_MINUTES;
}

/**
 * SLA countdown for uncontacted new leads.
 * @returns {{ breached: boolean, minutesLeft: number, minutesOver: number, slaMinutes: number } | null}
 */
export function getSlaStatus(lead, slaMinutes = DEFAULT_SLA_MINUTES) {
  if (lead?.mark !== "New" || lead?.connected_time) return null;

  const created = Date.parse(lead.createdAt || lead.created_at);
  if (Number.isNaN(created)) return null;

  const deadlineMs = created + slaMinutes * 60 * 1000;
  const remainingMs = deadlineMs - Date.now();

  return {
    breached: remainingMs <= 0,
    minutesLeft: Math.max(0, Math.ceil(remainingMs / 60000)),
    minutesOver: remainingMs < 0 ? Math.ceil(Math.abs(remainingMs) / 60000) : 0,
    slaMinutes,
  };
}
